import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import * as types from "../../../constants/ComponentConstants";
import { TochtTypeIds } from "../../../constants/DomainConstants";
import Row from "../../common/Row";
import FieldSet from "../../common/Fieldset";
import icoonVTTForKids from "../../../../js/images/Icoontjes-Kinderen.png";
import IcoonGSport from "../../../../js/images/Icoontjes-Gsport.png";
import IconInstagram from "../../../images/Instagram.png";
import IconX from "../../../images/x.png";
import IconFacebook from "../../../images/facebook.png";


const DetailForm = (props) => {
    const {
        model
    } = props;

    const imageSource = "data:image/png;base64," + model.logo;

    const isFietstocht = model.tochtTypeId === TochtTypeIds.FIETSTOCHT;
    const isWandeltocht = model.tochtTypeId === TochtTypeIds.WANDELTOCHT;
    const toegankelijkheidLabel = isFietstocht ? "Afstanden geschikt voor G-sporters met eigen fiets:"
        : isWandeltocht ? "Afstanden geschikt voor rolstoelgebruikers en kinderwagens:"
        : null;
    const toonToegankelijkheid = toegankelijkheidLabel && model.toegankelijkheidGSporters && model.beschrijvingToegankelijkheid;
    const toonGSport = model.toegankelijkheidGSporters && (isFietstocht || isWandeltocht);

    const lussen = model.lussen.map((lus, i) => {
        return (
            <div key={i}>{lus.naam}{lus.afstandType ? ` - ${lus.afstandType}` : ""} ({lus.afstandKM} km)<br /></div>
        );
    });

    const prijzen = model.prijzen.map((prijs, i) => {
        return (
            <div key={i}>{prijs.omschrijving}: € {prijs.deelnameprijs}<br /></div>
        );
    });

    return (
        <Fragment>
            <div>
                <Section title={"Organisator"} color={types.COLOR_BLUE}>
                    <Row>
                        <div className="c-tag-list" style={{ overflow: "visible", top: "0%", marginTop: "-25px", float: 'right' }}>
                            {!toonGSport || <div className="c-tag" style={{ 'margin-right': '7px' }}>
                                <img src={IcoonGSport} title={'Tocht toegankelijk voor G-sporters'} />
                            </div>}
                            {!model.toegankelijkheidVoorKinderen || <div className="c-tag">
                                <img src={icoonVTTForKids} title={'Tocht geschikt voor kinderen jonger dan 12 jaar'} />
                            </div>}
                        </div>
                    </Row>
                    <FieldSet>
                        <Row><p className="o-col-6">Naam:</p><p className="o-col-6">{model.gekendInSportDb == "true" || model.gekendInSportDb === true ?
                            <p>
                                <i className="fa fa-external-link" style={{ "color": "#006fb7", "font-weight": "bold", "font-size": ".875rem" }}></i> &nbsp; <a style={{ "color": "#006fb7", "font-weight": "bold", "font-size": ".875rem" }}
                                    href={"http://" + model.organisatorUrl}
                                    target="_blank">
                                    {model.organisatorNaam}
                                </a>
                            </p>
                            :
                            model.organisatorNaam}</p></Row>
                    </FieldSet>
                    {
                        model.logo &&
                            <FieldSet>
                                <Row>
                                    <p className="o-col-6">
                                        &nbsp;
                                    </p>
                                    <p className="o-col-6">
                                        {
                                            !model.logo ||
                                            <div className="c-tag">
                                                <img src={imageSource} />
                                            </div>
                                        }
                                    </p>
                                </Row>
                            </FieldSet>
                    }
                    {model.contactpersoon &&
                        <FieldSet>
                                <Row>
                                    <p className="o-col-6">Contactpersoon:</p>
                                    <p className="o-col-6">{model.contactpersoon.voornaam + " " + model.contactpersoon.achternaam}<br />
                                        {model.contactpersoon.email ? <a style={{ "color": "#006fb7", "font-weight": "bold", "font-size": ".875rem" }} href={"mailto:" + model.contactpersoon.email}>{model.contactpersoon.email}</a> : null}<br />
                                        {model.contactpersoon.telefoon}
                                    </p>
                                </Row>
                        </FieldSet>
                    }
                    {model.contactpersoonTijdensActiviteit &&
                        <FieldSet>
                                <Row>
                                    <p className="o-col-6">Contactpersoon tijdens de tocht:</p>
                                    <p className="o-col-6">{model.contactpersoonTijdensActiviteit.voornaam + " " + model.contactpersoonTijdensActiviteit.achternaam}<br />
                                        {model.contactpersoonTijdensActiviteit.email ? <a style={{ "color": "#006fb7", "font-weight": "bold", "font-size": ".875rem" }} href={"mailto:" + model.contactpersoonTijdensActiviteit.email}>{model.contactpersoonTijdensActiviteit.email}</a> : null}<br />
                                        {model.contactpersoonTijdensActiviteit.telefoon}
                                    </p>
                                </Row>
                        </FieldSet>
                    }
                    {model.website &&
                        <FieldSet>
                            <Row><p className="o-col-6">Website:</p><p className="o-col-6"><i className="fa fa-external-link" style={{ "color": "#006fb7", "font-weight": "bold", "font-size": ".875rem" }}></i>&nbsp;<a style={{ "color": "#006fb7", "font-weight": "bold", "font-size": ".875rem" }}
                                href={model.website}
                                target="_blank">
                                {model.website}
                            </a></p>
                            </Row>
                        </FieldSet>
                    }
                    {(model.facebook || model.twitter || model.instagram) &&
                        <FieldSet>
                                <Row><p className="o-col-6">Sociale media:</p>
                                    <p className="o-col-6">
                                        {model.facebook ?
                                            <a style={{ "color": "#006fb7", "font-weight": "bold", "height": ".875rem", "width": ".975rem", "paddingRight": ".300rem" }}
                                                href={model.facebook}
                                                target="_blank">
                                                <img style={{ "height": ".875rem" }} src={IconFacebook} />
                                            </a>
                                            :
                                            null}
                                        {model.twitter ?
                                            <a style={{ "color": "#006fb7", "font-weight": "bold", "height": ".875rem", "width": ".975rem", "paddingRight": ".300rem" }}
                                                href={model.twitter}
                                                target="_blank">
                                                <img style={{ "height": ".875rem" }} src={IconX} />
                                            </a>
                                            :
                                            null}
                                        {model.instagram ?
                                            <a style={{ "color": "#006fb7", "font-weight": "bold", "height": ".975rem", "width": ".975rem", "paddingRight": ".300rem" }}
                                                href={model.instagram}
                                                target="_blank">
                                                <img style={{ "height": ".875rem", "width": ".875rem" }} src={IconInstagram} />
                                            </a>
                                            :
                                            null}
                                    </p></Row>
                        </FieldSet>
                    }
                </Section>
                <Section title={"Info over de tocht"} color={types.COLOR_CORAL}>
                    {model.tochtTypeNaam &&
                        <FieldSet>
                            <Row>
                                <p className="o-col-6">Type tocht:</p>
                                <p className="o-col-6">{model.tochtTypeNaam}</p>
                            </Row>
                        </FieldSet>
                    }
                    {model.coronaMaatregelenGerespecteerd &&
                        <FieldSet>
                            <Row>
                                <p className="o-col-12">Coronaproof</p>
                            </Row>
                        </FieldSet>
                    }
                     {model.beschrijvingVanDeTocht &&
                            <FieldSet>
                                    <Row>
                                    <p className="o-col-6">Omschrijving:</p>
                                    <p className="o-col-6">{model.beschrijvingVanDeTocht}</p>
                                </Row>
                        </FieldSet>
                    }
                    {model.lussen.length > 0 ?
                        <FieldSet>
                            <Row>
                                <p className="o-col-6">Afstanden:</p>
                                <p className="o-col-6">{lussen}</p>
                            </Row>
                        </FieldSet>
                    : null }
                     {model.prijzen.length > 0 ?
                        <FieldSet>
                            <Row>
                                <p className="o-col-6">Prijzen:</p>
                                <p className="o-col-6">{prijzen}</p>
                            </Row>
                        </FieldSet>
                    : null  }
                    <FieldSet>
                        <Row>
                            <p className="o-col-6">Voorzieningen onderweg:</p>
                            <p className="o-col-6">
                                {model.bevoorrading ? <p>Bevoorrading</p> : null}
                                {model.pechdienst ? <p>Pechdienst</p> : null}
                                {!model.bevoorrading && !model.pechdienst ? <p>Geen</p> : null}
                            </p>
                        </Row>
                    </FieldSet>
                    {toonToegankelijkheid ?
                        <FieldSet>
                            <Row>
                                <p className="o-col-6">{toegankelijkheidLabel}</p>
                                <p className="o-col-6" style={{ whiteSpace: "pre-line" }}>{model.beschrijvingToegankelijkheid}</p>
                            </Row>
                        </FieldSet>
                    : null }
                </Section>
                <Section title={model.aankomstGelijkAanStartPlaats == "true" || model.aankomstGelijkAanStartPlaats === true ? "Start/aankomstplaats" : "Startplaats"} color={types.COLOR_TURQUOISE_DARK}>
                    <FieldSet>
                        <Row>
                            <p className="o-col-6">Adres:</p>
                            <p className="o-col-6">
                                {model.startplaatsNaam ? <p>{model.startplaatsNaam}</p> : null}
                                {model.startplaatsStraatEnNummer ? <p>{model.startplaatsStraatEnNummer}</p> : null}
                                {model.startplaatsPostcode && model.startplaatsGemeente ? <p>{model.startplaatsPostcode + " " + model.startplaatsGemeente}</p> : null}
                                {model.startplaatsPostcode && !model.startplaatsGemeente ? <p>{model.startplaatsPostcode}</p> : null}
                                {!model.startplaatsPostcode && model.startplaatsGemeente ? <p>{model.startplaatsGemeente}</p> : null}
                                {model.startplaatsLand ? <p>{model.startplaatsLand}</p> : null}
                            </p>
                        </Row>
                    </FieldSet>
                    <FieldSet>
                        <Row>
                            <p className="o-col-6">Voorzieningen:</p>
                            <p className="o-col-6">
                                {model.bewaakteFietsstallingStart ? <p>Bewaakte fietsenstalling</p> : null}
                                {model.drankgelegenheidStart ? <p>Drankgelegenheid</p> : null}
                                {model.kleedkamersStart && !model.kleedkamersManVrouwStart ? <p>Kleedkamers</p> : null}
                                {model.ehboStart ? <p>EHBO</p> : null}
                                {model.parkingStart ? <p>Parking</p> : null}
                                {model.herstellingspostStart ? <p>Herstellingspost</p> : null}
                                {model.kleedkamersManVrouwStart ? <p>Kleedkamers man/vrouw</p> : null}
                                {model.verhuurMTB ? <p>Verhuur mountainbike</p> : null}
                                {model.aankomstGelijkAanStartPlaats && model.douches && !model.douchesManVrouw ? <p>Douches</p> : null}
                                {model.aankomstGelijkAanStartPlaats && model.aandenken ? <p>Aandenken</p> : null}
                                {model.aankomstGelijkAanStartPlaats && model.douchesManVrouw ? <p>Douches man/vrouw</p> : null}
                                {model.aankomstGelijkAanStartPlaats && model.afspuitstand ? <p>Afspuitstand</p> : null}
                                {model.geenVoorzieningStart && ((model.geenVoorzieningAankomst && model.aankomstGelijkAanStartPlaats) || !model.aankomstGelijkAanStartPlaats) ? <p>Geen</p> : null}
                            </p>
                        </Row>
                    </FieldSet>
                </Section>
                {
                    model.aankomstGelijkAanStartPlaats ||
                    <Section title={"Aankomstplaats"} color={types.COLOR_MINT}>
                        <FieldSet>
                            <Row>
                                <p className="o-col-6">Adres:</p>
                                <p className="o-col-6">
                                    {model.aankomstNaam ? <p>{model.aankomstNaam}</p> : null}
                                    {model.aankomstStraatEnNummer ? <p>{model.aankomstStraatEnNummer}</p> : null}
                                    {model.aankomstPostcode && model.aankomstGemeente ? <p>{model.aankomstPostcode + " " + model.aankomstGemeente}</p> : null}
                                    {model.aankomstPostcode && !model.aankomstGemeente ? <p>{model.aankomstPostcode}</p> : null}
                                    {!model.aankomstPostcode && model.aankomstGemeente ? <p>{model.aankomstGemeente}</p> : null}
                                    {model.aankomstLand ? <p>{model.aankomstLand}</p> : null}
                                </p>
                            </Row>
                        </FieldSet>
                        {<FieldSet>
                            <Row>
                                <p className="o-col-6">Voorzieningen:</p>
                                <p className="o-col-6">
                                    {model.bewaakteFietsstallingAankomst ? <p>Bewaakte fietsenstalling</p> : null}
                                    {model.drankgelegenheidAankomst ? <p>Drankgelegenheid</p> : null}
                                    {model.kleedkamersAankomst && !model.kleedkamersManVrouwAankomst ? <p>Kleedkamers</p> : null}
                                    {model.ehboAankomst ? <p>EHBO</p> : null}
                                    {model.parkingAankomst ? <p>Parking</p> : null}
                                    {model.herstellingspostAankomst ? <p>Herstellingspost</p> : null}
                                    {model.kleedkamersManVrouwAankomst ? <p>Kleedkamers man/vrouw</p> : null}
                                    {model.douches && !model.douchesManVrouw ? <p>Douches</p> : null}
                                    {model.aandenken ? <p>Aandenken</p> : null}
                                    {model.douchesManVrouw ? <p>Douches man/vrouw</p> : null}
                                    {model.afspuitstand ? <p>Afspuitstand</p> : null}
                                    {model.geenVoorzieningAankomst ? <p>Geen</p> : null}
                                </p>
                            </Row>
                        </FieldSet>}
                    </Section>
                }
            </div>
        </Fragment >
    );
};

DetailForm.propTypes = {
    model: PropTypes.object
};

export default DetailForm;